import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    epsilonSegments: [],
    categories: [],
  },
  mutations,
  actions,
  getters: {
    epsilonSegments: (state) => state.epsilonSegments,
  },
};
